import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "./Login.css";
import API_URL from "../../src/Config";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";

const extractBackendErrorMessage = (error) => {
  const data = error?.response?.data;

  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }

  const candidates = [
    data?.message,
    data?.error,
    data?.detail,
    data?.msg,
    Array.isArray(data?.errors) ? data.errors[0]?.message : undefined,
    Array.isArray(data?.errors) ? data.errors[0]?.msg : undefined,
  ];

  return candidates.find(
    (value) => typeof value === "string" && value.trim().length > 0
  );
};

const Login = ({ onLogin }) => {
  const [resendTimer, setResendTimer] = useState(0);
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("otp"); // "email" | "otp"
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const handleSubmit = (e) => {
    e.preventDefault();
    handleSignIn();
  };
  useEffect(() => {
  if (resendTimer <= 0) return;
  const interval = setInterval(() => {
    setResendTimer((prev) => {
      if (prev <= 1) {
        clearInterval(interval);
        return 0;
      }
      return prev - 1;
    });
  }, 1000);
  return () => clearInterval(interval);
}, [resendTimer]);
  const handleOtpVerify = async (e) => {
  e.preventDefault();
  const otpValue = otp.join("");
  if (otpValue.length < 6) {
    setAlertMessage({ message: "Please enter the 6-digit OTP", type: "error" });
    return;
  }
  try {
    setLoading(true);
    const response = await axios.post(`${API_URL}/api/login`, {
      contact: name,
      otp: otpValue,
    });
    if (response.status === 200) {
      
      const { authKey, refresh_token, email, name: userName, user_role } = response.data;
      if (refresh_token) localStorage.setItem("refresh_token", refresh_token);
      if (onLogin) onLogin(authKey, userName, email, user_role, refresh_token);
      navigate("/dashboard");
    }
    } catch (error) {
      const backendMessage = extractBackendErrorMessage(error);
      setAlertMessage({
      message: backendMessage || "Invalid OTP. Please try again.",
      type: "error",
    });
  } finally {
    setLoading(false);
  }
};
  const handleSignIn = async () => {
    // Reset error messages
    if(activeTab === "otp"){
       try {
      setLoading(true);
      const response = await axios.post(`${API_URL}/api/send-login-otp`, {
        contact:name,
        
      });
      setAlertMessage({
              message: response.data.message || "OTP sent successfully" ,
              type: "success",
            });
      setOtpSent(true);
      setResendTimer(30); 
    } catch (error) {
      
    const backendMessage = extractBackendErrorMessage(error);
      
    console.error("Error during sign-in:", error);

      if (error.response) {
        // Check for specific error responses from the backend
        if (error.response.status === 400) {
          const errorMessage = backendMessage;

          // Custom handling for specific error cases
          if (errorMessage?.includes("Invalid email")) {
            setAlertMessage({
              message: "The email address entered is not registered.",
              type: "error",
            });
          } else if (errorMessage?.includes("Invalid password")) {
            setAlertMessage({
              message: "The password entered is incorrect.",
              type: "error",
            });
          } else {
            // Handle other 401 errors (invalid credentials)
            setAlertMessage({
              message: errorMessage || "Invalid credentials",
              type: "error",
            });
          }
        } else if (error.response.status === 404) {
          const errorMessage = backendMessage;
          setAlertMessage({
              message: errorMessage || "Invalid credentials",
              type: "error",
            });
         }else {
          // Handle other types of errors
          setAlertMessage({
            message:
              backendMessage ||
              "Invalid password or Email. Please check your credentials and try again",
            type: "error",
          });
        }
      } else {
        setAlertMessage({
          message: "Network error. Please check your connection.",
          type: "error",
        });
      }
    } finally {
      setLoading(false);
    }
      
    } else if(activeTab === "email"){
    setUsernameError("");
    setPasswordError("");
    setAlertMessage("");

    // Input validation
    if (!name.trim()) {
      setUsernameError("Enter Your Email !");
      return;
    }

    if (!password.trim()) {
      setPasswordError("Enter Your Password !");
      return;
    }

    try {
      setLoading(true);
      // Send login request to backend
      const response = await axios.post(`${API_URL}/api/login`, {
        contact:name,
        password,
      });

      if (response.status === 200) {
        const { authKey, refresh_token, email, name, user_role, message } =
          response.data;

        // Save refresh_token to localStorage
        if (refresh_token) {
          localStorage.setItem("refresh_token", refresh_token);
        }
        
        if (onLogin) {
          onLogin(authKey, name, email, user_role, refresh_token); // Pass refresh_token to App.js
        }

        setAlertMessage(message);
        navigate("/dashboard");
      } else {
        setAlertMessage("Unexpected response from server");
      }
    } catch (error) {
      const backendMessage = extractBackendErrorMessage(error);
      console.error("Error during sign-in:", error);

      if (error.response) {
        // Check for specific error responses from the backend
        if (error.response.status === 400) {
          const errorMessage = backendMessage;

          // Custom handling for specific error cases
          if (errorMessage?.includes("Invalid email")) {
            setAlertMessage({
              message: "The email address entered is not registered.",
              type: "error",
            });
          } else if (errorMessage?.includes("Invalid password")) {
            setAlertMessage({
              message: "The password entered is incorrect.",
              type: "error",
            });
          } else {
            // Handle other 401 errors (invalid credentials)
            setAlertMessage({
              message: errorMessage || "Invalid credentials",
              type: "error",
            });
          }
        } else {
          // Handle other types of errors
          setAlertMessage({
            message:
              backendMessage ||
              "Invalid password or Email. Please check your credentials and try again",
            type: "error",
          });
        }
      } else {
        setAlertMessage({
          message: "Network error. Please check your connection.",
          type: "error",
        });
      }
    } finally {
      setLoading(false);
    }
  }
  };
  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
    setAlertMessage("");
    setUsernameError("");
    setPasswordError("");
    setPassword("");
  };

  const handleRegisterClick = () => {
    navigate("/subscription-plan");
  };

  return (
    <div className="login-container">
      <div className="login-content-left">
        <div className="login-content-left-content">
          <div className="login-content-left-content">
            <video autoPlay loop muted playsInline className="login-video">
              <source src={"/assests/video/loginpageca.mp4"} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
      <div className="login-content-right">
        <div className="login-content-right-content">
          <div className="login-heading">
            <img src="/Office_align.png" alt="" className="login-logo" />
          </div>
          <div className="login-body">
            <div className="welcome">Welcome !</div>
          
              <div className="login-tab-switcher">
                <button
                type="button"
                className={`login-tab-btn ${activeTab === "otp" ? "active" : ""}`}
                onClick={() => handleTabSwitch("otp")}
              >
                OTP
              </button>
              <button
                type="button"
                className={`login-tab-btn ${activeTab === "email" ? "active" : ""}`}
                onClick={() => handleTabSwitch("email")}
              >
                Password
              </button>
              
            </div>
            {alertMessage && (
              <div
                className={`alert ${
                  alertMessage.type === "error"
                    ? "alert-danger"
                    : "alert-success"
                }`}
                style={{
                  marginBottom: "10px",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
                role="alert"
              >
                {alertMessage.message}
              </div>
            )}
          { activeTab === "email" && 
            (   <div className="login-form">
              <form onSubmit={handleSubmit}>
                {/* Email */}
                <div className="login-form-table">
                  <label htmlFor="username">Email / Phone Number:</label>
                  <div
                    className={`input-with-icon ${
                      usernameError ? "has-error" : ""
                    }`}
                  >
                    <FiMail className="input-icon" aria-hidden="true" />
                    <input
                      type="text"
                      id="username"
                      className={`form-controls ${
                        usernameError ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Email / Phone Number"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  {usernameError && (
                    <div className="invalid-feedbacks">{usernameError}</div>
                  )}
                </div>

                {/* Password */}
                <div className="login-form-table">
                  <label htmlFor="password">Password:</label>
                  <div
                    className={`input-with-icon ${
                      passwordError ? "has-error" : ""
                    }`}
                  >
                    <FiLock className="input-icon" aria-hidden="true" />
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      className={`form-controls ${
                        passwordError ? "is-invalid" : ""
                      }`}
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className="toggle-password"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FiEyeOff /> : <FiEye />}
                    </span>
                  </div>
                  {passwordError && (
                    <div className="invalid-feedbacks">{passwordError}</div>
                  )}
                </div>
                <div className="forget-password auth-link-row">
                  <Link to="/forgot-password" className="forget-password-link">
                    Forgot Password?
                  </Link>
                  <span className="auth-link-separator" aria-hidden="true">|</span>
                  <button
                    type="button"
                    className="forget-password-link register-inline-link"
                    onClick={handleRegisterClick}
                  >
                    Register
                  </button>
                </div>
                <div className="login-button">
                  <button
                    type="submit"
                    disabled={loading}
                    className="login-btn"
                  >
                    {loading ? <div className="loads" /> : "LOG IN"}
                  </button>
                </div>
              </form>
            </div> )}
           { activeTab === "otp" && 
            ( <div className="login-form">
            {!otpSent ? (
              <form onSubmit={handleSubmit}>
                {/* Email */}
                <div className="login-form-table">
                  <label htmlFor="username">Email / Phone Number:</label>
                  <div
                    className={`input-with-icon ${
                      usernameError ? "has-error" : ""
                    }`}
                  >
                    <FiMail className="input-icon" aria-hidden="true" />
                    <input
                      type="text"
                      id="mobile-number"
                      className={`form-controls ${
                        usernameError ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Email / Phone Number"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  {usernameError && (
                    <div className="invalid-feedbacks">{usernameError}</div>
                  )}
                </div>

                {/* Password */}
                
                <div className="forget-password auth-link-row">
                  <Link to="/forgot-password" className="forget-password-link">
                    Forgot Password?
                  </Link>
                  <span className="auth-link-separator" aria-hidden="true">|</span>
                  <button
                    type="button"
                    className="forget-password-link register-inline-link"
                    onClick={handleRegisterClick}
                  >
                    Register
                  </button>
                </div>
                <div className="login-button">
                  <button
                    type="submit"
                    disabled={loading}
                    className="login-btn"
                  >
                    {loading ? <div className="loads" /> : "SEND OTP"}
                  </button>
                </div>
              </form> ):  (
      <form onSubmit={handleOtpVerify}>
        {/* OTP sent to banner */}
        <div className="otp-sent-banner">
          <FiMail className="otp-banner-icon" />
          <div>
            <span className="otp-sent-label">OTP sent to</span>
            <span className="otp-sent-contact">{name}</span>
          </div>
        </div>

        {/* 6 digit OTP boxes */}
        <div className="login-form-table">
          <label>Enter 6-digit Code</label>
          <div className="otp-boxes">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength={1}
                className="otp-box"
                value={digit}
                onChange={(e) => {
                  const val = e.target.value
                  const newOtp = [...otp];
                  
                  newOtp[index] = val;
                  setOtp(newOtp);
                  if (val && index < 5) {
                    document.getElementById(`otp-${index + 1}`)?.focus();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace" && !otp[index] && index > 0) {
                    document.getElementById(`otp-${index - 1}`)?.focus();
                  }
                }}
              />
            ))}
          </div>
        </div>

        <div className="login-button">
          <button type="submit" disabled={loading} className="login-btn">
            {loading ? <div className="loads" /> : "Verify & Sign In"}
          </button>
        </div>

        <div className="otp-footer">
          <span>Didn't receive the code? </span>
          <button
              type="button"
              className="otp-resend-btn"
              disabled={resendTimer > 0}
              onClick={() => {
                setOtp(["", "", "", "", "", ""]);
                handleSignIn();
              }}
              style={{ opacity: resendTimer > 0 ? 0.5 : 1, cursor: resendTimer > 0 ? "not-allowed" : "pointer" }}
            >
              {resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend"}
            </button>
        </div>
        <div className="otp-footer">
          <button type="button" className="otp-resend-btn" onClick={() => { setOtpSent(false); setName(""); setOtp(["","","","","",""]); }}>
            Use a different email / phone number
          </button>
        </div>
      </form>
    )}
            </div>)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
